module.exports = __webpack_public_path__ + "img/logo2.d8d48a6b.png";